
import format, { FORMAT } from '../core/format'
import wuxing, { WUXING } from '../core/wuxing'
import momenttime, { MOMENT_TIME } from '../../momenttime'
import { UTILS } from '../../utils'

var SEARCH_DATA_MANAGER = {
    // 获取天干数据数组
    getTianGanListByCompData(compData) {
        var resultList = [];
        var index = compData.text ? FORMAT.getDiZhiIndexByText(compData.text) : -1;
        for(var i = 0; i < 10; i++){
            var data = FORMAT.getTianGanWordDataByIndex(i);
            if(index == -1){
                // 对比数据为空的情况
                resultList.push(data);
            }else{
                // 对比数据不为空，取同奇偶性
                if((i+index)%2 == 0){
                    resultList.push(data);
                }
            }
        }
        // console.log('getTianGanListByCompData-----', compData.text, resultList);
        return resultList;
    },
    // 获取地支数组数据
    getDiZhiListByCompData(compData) {
        var resultList = [];
        var index = compData.text ? FORMAT.getTianGanIndexByText(compData.text) : -1;
        for(var i = 0; i < 12; i++){
            var data = FORMAT.getDiZhiWordDataByIndex(i);
            if(index == -1){
                // 对比数据为空的情况
                resultList.push(data);
            }else{
                // 对比数据不为空，取同奇偶性
                if((i+index)%2 == 0){
                    resultList.push(data);
                }
            }
        }
        // console.log('getDiZhiListByCompData-----', compData.text, resultList);
        return resultList;
    },
    // 获取五行数组数据
    getWuXingList() {
        var resultList = [];
        for(var i = 0; i < 5; i++){
            var data = WUXING.getWuXingDataByIndex(i);
            resultList.push(data);
        }
        console.log('getWuXingList-----', resultList);
        return resultList;
    },
    // 搜索页获取搜索出来的数据
    getSearchResultListByWord(origiData, word, filterData) {
        var resultList = origiData;
        var resultList = resultList.filter(data => data.name.replace(/\s*/g,"").toLowerCase().indexOf(word.toLowerCase()) !== -1);
        // 增加命局条件
        if(filterData.situation > 0){
            resultList = resultList.filter(data => data.situation == filterData.situation);
        }
        // 增加性别条件
        if(filterData.sex != -1) {
            var sexWord = filterData.sex == 0 ? '男' : '女';
            resultList = resultList.filter(data => data.sex == sexWord);
        }
        // 年龄的升序or降序
        if(filterData.age == 0){
            resultList.sort((a, b) => {return MOMENT_TIME.getAgeByTimeStamp(a.birthday * 1000) - MOMENT_TIME.getAgeByTimeStamp(b.birthday * 1000)})
        }else{
            resultList.sort((a, b) => {return MOMENT_TIME.getAgeByTimeStamp(b.birthday * 1000) - MOMENT_TIME.getAgeByTimeStamp(a.birthday * 1000)})
        }
        // console.log('getSearchResultListByWord------', resultList);
        return resultList;
    },
    // 搜索页获取标签搜索的结果
    getSearchResultListByLabel(origiData, labelId) {
        var resultList = origiData;
        resultList = resultList.filter(data => UTILS.getLabelStringEqual(data.label, labelId))
        console.log('getSearchResultListByLabel', resultList, labelId)
        return resultList;
    },
    // 修改数据后更新搜索结果列表数据
    updateSearchResultListByData(origiData, newList) {
        for(var newData of newList) {
            var index = UTILS.getIdIndexInObjectArray(origiData, newData.id);
            if(index != -1){
                origiData[index] = Object.assign({}, newData);
            }
            // console.log('updateSearchResultListByData----', newData);
        }
        return origiData;
    },
    // 删除数据后更新搜索结果列表数据
    deleteSearchResultListByDataId(origiData, dataId) {
        for(var recordData of origiData) {
            var index = origiData.indexOf(recordData);
            if(recordData.id == dataId) {
                origiData.splice(index, 1);
            }
        }
        return origiData;
    },
    // 高级搜索页根据干支or五行搜索出来的数据
    getSearchResultListByChooseBoxList(origiData, chooseBoxList) {
        var choosedArr = [], tempWord = '', resultList = origiData;
        for(var boxList of chooseBoxList) {
            for( var boxData of boxList) {
                tempWord = boxData.choosedData.text ? boxData.choosedData.text : tempWord;
                choosedArr.push(boxData.choosedData.text);
            }
        }
        var me = this;
        var type = FORMAT.getWordTypeByText(tempWord);
        resultList = resultList.filter(function(data){
            return me.compareWordArr(type, data, choosedArr);
        });
        resultList.sort((a, b) => {return b.glance_time - a.glance_time});
        return resultList;
    },
    // 比较干支里的八个字里是否有相同的
    compareWordArr(type, data, choosedArr) {
        var curArr = this.getWordArrByDataList(type, data.eightWordArr);
        // console.log('compareWordArr-----', type, data, choosedArr, curArr)
        var result, tempArr = [];
        for(var i = 0; i < choosedArr.length; i++){
            var word = choosedArr[i];
            if(word){
                var tempValue = curArr[i] == word ? true : false;
                if(tempArr.length == 0){
                    result = tempValue;
                }else{
                    result = result && tempValue;
                }
                tempArr.push(tempValue);
            }
        }
        return result;
    },
    // 获取日干八字数据的文字数组
    getWordArrByDataList(type, dataList) {
        var choosedArr = [];
        for(var subList of dataList) {
            for(var data of subList) {
                if(type == 'wuxing'){
                    choosedArr.push(data.propXing);
                }else{
                    choosedArr.push(data.text);
                }
            }
        }
        return choosedArr;
    }
}


export {
    SEARCH_DATA_MANAGER
}